var map = {
	"./IconsNew/papsi_back.svg": 2154,
	"./IconsNew/papsi_ballot.svg": 2937,
	"./IconsNew/papsi_check.svg": 8721,
	"./IconsNew/papsi_close.svg": 7325,
	"./IconsNew/papsi_down.svg": 3947,
	"./IconsNew/papsi_edit.svg": 7167,
	"./IconsNew/papsi_error.svg": 8303,
	"./IconsNew/papsi_info.svg": 6675,
	"./IconsNew/papsi_logout.svg": 1717,
	"./IconsNew/papsi_mobile_yellow.svg": 7988,
	"./IconsNew/papsi_password_invisible.svg": 108,
	"./IconsNew/papsi_password_visible.svg": 8799,
	"./IconsNew/papsi_proceed.svg": 6331,
	"./IconsNew/papsi_qr.svg": 3570,
	"./IconsNew/papsi_qr_yellow.svg": 6333,
	"./IconsNew/papsi_question.svg": 1715,
	"./IconsNew/papsi_refresh.svg": 688,
	"./IconsNew/papsi_toggleside.svg": 4022,
	"./IconsNew/papsi_warning.svg": 9153,
	"./icons/close_eye.svg": 4015,
	"./icons/eye.svg": 4426,
	"./icons/hi.png": 9888,
	"./icons/papsi_branches.svg": 8745,
	"./icons/papsi_cloud_upload.svg": 2924,
	"./icons/papsi_company.svg": 9286,
	"./icons/papsi_contact_us_icon.svg": 1398,
	"./icons/papsi_election.svg": 8020,
	"./icons/papsi_error_icon.svg": 4919,
	"./icons/papsi_forgot_password_icon.svg": 8312,
	"./icons/papsi_help.svg": 416,
	"./icons/papsi_home.svg": 3392,
	"./icons/papsi_location_icon.svg": 3228,
	"./icons/papsi_profile.svg": 9884,
	"./icons/papsi_success_icon.svg": 3054,
	"./icons/papsi_warning.svg": 6623,
	"./icons/qr.svg": 6690,
	"./icons/search_user.svg": 7267,
	"./images/Backgroundpapsi.jpg": 9724,
	"./images/Facebook_f_logo.png": 9528,
	"./images/Instagram_logo.png": 1969,
	"./images/LoginBG.jpg": 2425,
	"./images/WEB.jpg": 2585,
	"./images/WEB2.jpg": 7159,
	"./images/alert/papsi_error_icon.svg": 178,
	"./images/alert/papsi_info_icon.svg": 3728,
	"./images/alert/papsi_success_icon.svg": 9547,
	"./images/alert/papsi_warning_icon.svg": 2112,
	"./images/banner_eft-2.png": 4182,
	"./images/banner_eft.png": 8299,
	"./images/banner_placeholder.png": 27,
	"./images/banner_referendum.png": 313,
	"./images/circled_check.svg": 6100,
	"./images/ga_assembly.jpg": 5628,
	"./images/image.png": 4,
	"./images/loader/papsi_loading_icon.gif": 5874,
	"./images/nav_left.svg": 9702,
	"./images/nav_right.svg": 1989,
	"./images/papsi-no-events.png": 330,
	"./images/papsi_about_icon.svg": 4560,
	"./images/papsi_account.svg": 8554,
	"./images/papsi_account_icon.svg": 5806,
	"./images/papsi_arrow_icon.svg": 5800,
	"./images/papsi_avatar_icon.svg": 2002,
	"./images/papsi_back_icon.svg": 3004,
	"./images/papsi_back_primary_icon.svg": 873,
	"./images/papsi_ballot.svg": 1311,
	"./images/papsi_calculator.png": 2305,
	"./images/papsi_calendar.svg": 7107,
	"./images/papsi_check.svg": 1127,
	"./images/papsi_check_icon.svg": 6145,
	"./images/papsi_ck_off_icon.svg": 9035,
	"./images/papsi_ck_on_icon.svg": 4007,
	"./images/papsi_ck_on_icon_neg.svg": 7696,
	"./images/papsi_close.svg": 2907,
	"./images/papsi_close_grey.svg": 7023,
	"./images/papsi_contact.svg": 2343,
	"./images/papsi_dashboard.svg": 3359,
	"./images/papsi_dashboard_icon.svg": 9033,
	"./images/papsi_delete_icon.svg": 9248,
	"./images/papsi_dividend.png": 5168,
	"./images/papsi_down.svg": 8149,
	"./images/papsi_edit_icon.svg": 2387,
	"./images/papsi_edit_icon_gray.svg": 5643,
	"./images/papsi_edit_icon_white.svg": 6797,
	"./images/papsi_eft.png": 1946,
	"./images/papsi_eft_poster.jpg": 1156,
	"./images/papsi_election_icon.svg": 3236,
	"./images/papsi_empty.png": 8493,
	"./images/papsi_error_icon.svg": 7151,
	"./images/papsi_events.svg": 1146,
	"./images/papsi_forgot_password_icon.svg": 288,
	"./images/papsi_funrun.jpg": 6647,
	"./images/papsi_help.svg": 8472,
	"./images/papsi_info_icon.svg": 4859,
	"./images/papsi_information_icon.svg": 9915,
	"./images/papsi_invi_icon.svg": 7677,
	"./images/papsi_ledger.png": 7958,
	"./images/papsi_list_icon.svg": 1615,
	"./images/papsi_lock_icon.svg": 8012,
	"./images/papsi_login_icon.svg": 8960,
	"./images/papsi_logo_nav_icon.png": 1180,
	"./images/papsi_logout.svg": 5271,
	"./images/papsi_logout_icon.svg": 4529,
	"./images/papsi_membership.svg": 3985,
	"./images/papsi_menu_icon.svg": 4548,
	"./images/papsi_next.svg": 4110,
	"./images/papsi_next_green.svg": 9034,
	"./images/papsi_otp_icon.svg": 2240,
	"./images/papsi_otpin_icon.svg": 9827,
	"./images/papsi_password_icon.svg": 4330,
	"./images/papsi_password_primary_icon.svg": 4539,
	"./images/papsi_patref.png": 8475,
	"./images/papsi_pencil_icon.svg": 1226,
	"./images/papsi_phone.svg": 3667,
	"./images/papsi_profile.svg": 996,
	"./images/papsi_registration_icon.svg": 8934,
	"./images/papsi_security.svg": 5143,
	"./images/papsi_selected_adcom.svg": 8529,
	"./images/papsi_selected_elecom.svg": 5926,
	"./images/papsi_selected_icon.svg": 6586,
	"./images/papsi_selection_icon.svg": 395,
	"./images/papsi_selection_icon_audit.svg": 5071,
	"./images/papsi_selection_icon_elecom.svg": 9561,
	"./images/papsi_service.svg": 4970,
	"./images/papsi_settings.svg": 6066,
	"./images/papsi_settings_icon.svg": 9606,
	"./images/papsi_signature_icon.svg": 9243,
	"./images/papsi_social_media.svg": 3517,
	"./images/papsi_star_off_icon.svg": 3409,
	"./images/papsi_star_on_icon.svg": 5877,
	"./images/papsi_success_icon.svg": 5718,
	"./images/papsi_up.svg": 7130,
	"./images/papsi_up_icon.svg": 1406,
	"./images/papsi_vis_icon.svg": 4887,
	"./images/pnb-logo.png": 6811,
	"./images/pnb_icon.png": 2619,
	"./images/question_mark_icon.svg": 4047,
	"./images/service.svg": 9240,
	"./images/signature.jpg": 1181,
	"./tailwind.css": 5357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7909;